import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_904_28236",
			width: 20,
			height: 20,
			x: 0,
			y: 0,
			maskUnits: "userSpaceOnUse",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M0 0H20V20H0z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_904_28236)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#545F7E",
				d: "M17.718 16.355l-3.554-3.546a6.757 6.757 0 10-1.355 1.355l3.546 3.554a.963.963 0 101.363-1.363zM8.786 13.59a4.781 4.781 0 110-9.562 4.781 4.781 0 010 9.562z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
